import React, { useEffect, useState } from 'react';
import { useHeader } from '../../context/HeaderContext';
import { getPartnerDocuments } from '../../api/partner';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaFileAlt, FaDownload } from 'react-icons/fa';

const DocumentRepository = () => {
  const { setHeaderTitle } = useHeader();
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    setHeaderTitle('Document Repository');
    fetchDocuments();
  }, [setHeaderTitle]);

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      const data = await getPartnerDocuments();
      setDocuments(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Error fetching documents:', error);
      toast.error('Failed to load documents');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className='flex items-center justify-center py-20'>
        <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-primary'></div>
      </div>
    );
  }

  return (
    <div className='w-full'>
      <section className='bg-white rounded-md shadow-sm p-6'>
        <div className='flex justify-between items-center mb-6'>
          <h2 className='text-xl font-bold text-fontBlack'>My Documents</h2>
        </div>

        {documents.length > 0 ? (
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
            {documents.map((doc, index) => (
              <div
                key={doc._id || doc.id || index}
                className='border border-border rounded-lg p-4 hover:shadow-md transition-shadow'
              >
                <div className='flex items-start gap-3 mb-3'>
                  <div className='text-primary text-3xl'>
                    <FaFileAlt />
                  </div>
                  <div className='flex-1'>
                    <h3 className='font-semibold text-fontBlack text-base mb-1'>
                      {doc.documentType?.name || doc.type || 'Document'}
                    </h3>
                    <p className='text-sm text-secondary'>
                      Uploaded: {formatDate(doc.uploadedAt || doc.createdAt)}
                    </p>
                  </div>
                </div>

                {(doc.documentUrl || doc.fileUrl) && (
                  <a
                    href={doc.documentUrl || doc.fileUrl}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='flex items-center gap-2 text-primary hover:text-primaryHoverDark text-sm font-medium'
                  >
                    <FaDownload />
                    Download
                  </a>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className='text-center py-12'>
            <div className='text-chipYellow text-6xl mb-4 flex justify-center'>
              <FaFileAlt />
            </div>
            <p className='text-base font-medium text-fontBlack'>No documents found</p>
            <p className='text-sm text-secondary mt-2'>
              Your uploaded documents will appear here
            </p>
          </div>
        )}
      </section>

      <ToastContainer position="bottom-right" autoClose={2000} />
    </div>
  );
};

export default DocumentRepository;
